import type { ColumnsType } from 'antd/es/table';
import { useExpiryReportQuery, useLazyExportExpiryXlsxQuery } from '@/entities/reports';
import type { ExpiryReportRow } from '@/entities/reports';
import { ReportPage } from '@/shared/ui';
import { formatDate } from '@/shared/lib/date';

/** §13, §11.4: партии с остатком по сроку годности (ближайшие сверху). */
export function ExpiryReportPage() {
  const { data, isFetching } = useExpiryReportQuery(undefined, { pollingInterval: 30_000 });
  const [exportXlsx] = useLazyExportExpiryXlsxQuery();

  const columns: ColumnsType<ExpiryReportRow> = [
    { title: 'Товар', dataIndex: 'categoryName' },
    { title: 'Срок годности', dataIndex: 'expiryDate', width: 130, render: (v: string) => formatDate(v) },
    { title: 'Остаток, шт', dataIndex: 'qtyRemaining', width: 110, align: 'right' },
    { title: 'Дата прихода', dataIndex: 'receivedDate', width: 130, render: (v: string) => formatDate(v) },
  ];

  return (
    <ReportPage
      title="Сроки годности"
      columns={columns}
      data={data?.rows ?? []}
      loading={isFetching}
      rowKey="batchId"
      onExport={() => exportXlsx().unwrap()}
      exportFilename="Сроки годности.xlsx"
    />
  );
}
